import {TextTranslations} from '../question/utils';

export interface Category {
  code: CategoryCode;
  maxCoverage: number;
  name: TextTranslations;
}

export enum CategoryCode {
  C1 = 'C1',
  C2 = 'C2',
  C3 = 'C3',
  C4 = 'C4',
  C5 = 'C5',
  INELIGIBLE = 'INELIGIBLE',
}

export const categoryCodeToNumber = {
  [CategoryCode.C1]: 1,
  [CategoryCode.C2]: 2,
  [CategoryCode.C3]: 3,
  [CategoryCode.C4]: 4,
  [CategoryCode.C5]: 5,
  [CategoryCode.INELIGIBLE]: 666,
};

export const pickMaxCategoryCode = (first: CategoryCode, second: CategoryCode): CategoryCode => {
  return categoryCodeToNumber[first] > categoryCodeToNumber[second] ? first : second;
};
